import { TraitRegistryItem } from '../TraitRegistryItem';
export class TraitTypeSlotKey extends TraitRegistryItem {
    constructor(init) {
        super(init);
        Object.assign(this, init);
    }
}
